import React from 'react'
import { connect } from 'react-redux'
import { getLinkguaType } from 'util/checkAuthentication'

const mapStateToProps = ({auth}) => {
  return { auth }
}

export const IfLoginType = connect(mapStateToProps)(({ auth, type, children }) => getLinkguaType(auth) === type ? (children) : null)

export const IfCustomer = ({children}) => (<IfLoginType type='customer'>{children}</IfLoginType>)
export const IfSpecialist = ({children}) => (<IfLoginType type='specialist'>{children}</IfLoginType>)



// WEBPACK FOOTER //
// ./containers/IfLoginType.js